import axios, { AxiosInstance } from 'axios';
import Configuration from '../utils/Configuration';
import store from '@/store/Store';
import { setUpRedirectToLogin } from '@/api/utils/redirectToLogin';

function initAxios() {
  const $http = axios.create();
  const baseUrl = getBaseUrl();
  setBaseUrl($http, baseUrl);
  return $http;
}

function setBaseUrl($http: AxiosInstance, baseUrl: string) {
  $http.defaults.baseURL = baseUrl;
}

function getBaseUrl() {
  return Configuration.value('VUE_APP_ADMIN_API_BASE_URL');
}

const $httpNoAuth: AxiosInstance = initAxios();

export { $httpNoAuth, getBaseUrl, setBaseUrl };
